module.exports = __webpack_public_path__ + "static/people-logo-french-cf4cc0e9a00628e55c67e367f8b31725.png";